import React, { useEffect, useState } from "react";
import { authUtils } from "../utils/authUtils";
import authNegociosService from "../api/authNegociosService";

export const AuthContext = React.createContext();
export const AuthContextProvider = (props) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [negocioActivo, setNegocioActivo] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = authUtils.getToken();
    if (token) {
      authNegociosService
        .getDetails()
        .then((res) => {
          setUser(res.data);
          setNegocioActivo(authUtils.getNegocioActivo());
          setAuthenticated(true);
        })
        .finally(() => setMounted(true));
    } else {
      setMounted(true);
    }

    return () => {
      authUtils.saveNegocioActivo(negocioActivo);
    };
  }, []); // eslint-disable-line

  const logout = () => {
    authUtils.deleteToken();
    setAuthenticated(false);
    setNegocioActivo(null);
    setUser(null);
    // Refresh the page
    window.location.reload(false);
  };

  const defaultContext = {
    authenticated,
    setAuthenticated,
    mounted,
    negocioActivo,
    setNegocioActivo,
    user,
    setUser,
    logout,
  };

  return <AuthContext.Provider value={defaultContext}>{props.children}</AuthContext.Provider>;
};
